module.exports = __webpack_public_path__ + "img/cna-logo-white.eb4ba9d1.svg";